$(".buy-now-track").click(function(){
    console.log($(this).attr("price"))
    // fbq('track', 'Purchase', {
    //     currency: "USD", 
    //     value: parseFloat($(this).attr("price")), 
    //     content_ids: [$(this).attr("href")], 
    //     content_type: "product"
    // });
    fbq('trackCustom', 'BuyOnPrime'); 

    // ttq.track('Purchase', {
    //     currency: 'USD', 
    //     value: parseFloat($(this).attr("price")), 
    //     content_ids: $(this).attr("href"), 
    //     content_type: "product"
    // });

    ttq.track('BuyOnPrime');
    
    gtag('event', 'conversion', { 
        'send_to': 'AW-11140647690/u1f_CKqG3v4YEIqWo8Ap', 
        'transaction_id': $(this).attr("href"), 
    }); 
})

document.addEventListener("DOMContentLoaded", function () {
    
    // Product page accordion toggles (Description, What's Inside)
    document.querySelectorAll(".product-logo-title").forEach((toggleTitle) => {
      const panel = toggleTitle.nextElementSibling;
      if (!panel || !panel.classList.contains("ingredients")) return;

      const toggle = () => {
        const isOpen = panel.classList.toggle("show");
        toggleTitle.classList.toggle("open", isOpen);
        toggleTitle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      };

      toggleTitle.addEventListener("click", toggle);
      toggleTitle.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          toggle();
        }
      });
    });

    // Insta feed slider
    const feedWrapper = document.querySelector('.instafeed-new-layout-wrapper');
    const item = feedWrapper?.querySelector('.instafeed-new-layout-item');

    if (feedWrapper && item) {
      const halfItemWidth = item.offsetWidth / 2;
      feedWrapper.style.transform = `translateX(-${halfItemWidth}px)`;
    }

});
